const routes = {
  '/': 'Home',
  '/metadata-sp-download':          'Metadata Service Provider / Download from URL',
  '/metadata-sp-upload-zip':        'Metadata Service Provider / Upload ZIP',
  '/metadata-sp-checl-xsd':         'Metadata Service Provider / Check XSD',
  '/metadata-sp-check-strict':      'Metadata Service Provider / Check Strict',
  '/metadata-sp-check-certs':       'Metadata Service Provider / Check Certificates',
  '/metadata-sp-check-extra':       'Metadata Service Provider / Check Extra',
  '/request':                       'Request / SAML',
  '/request-check-strict':          'Request / Check Strict',
  '/request-check-certs':           'Request / Check Certificates',
  '/request-check-extra':           'Request / Check Extra',
  '/response':                      'Response / Test'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js